import { userConstants } from "../constants/login.constants";

 function changePassword(state = {}, action) {
    switch (action.type) {
        case userConstants.CHANGEPASSWORD_REQUEST:
            return {
                loading: true
            };
        case userConstants.CHANGEPASSWORD_SUCCESS:
            return {
                items: action.changePassword
            };
        case userConstants.CHANGEPASSWORD_FAILURE:
            return {
                error: action.errorChangePassword
            };
        default:
            return state
    }
}
export default changePassword;